import { IPaginationResult } from '@models/Equipment.model';
import { ITag, ITagLimitWithDesc } from '@models/Tag.model';
import { InfiniteData } from 'react-query';

import { SetState } from '@pages/Organization/utils/onOrgNameSubmit';
import { getDefaultTagBackground } from '@utils/getDefaultTagBackground';
import { TagsList } from './components/TagsList/TagsList';
// Todo: Make this available globally
function toITagLimitWithDesc(t: ITag): ITagLimitWithDesc {
  return {
    id: t.id,
    name: t.name,
    description: t.description,
    tagCategoryId: t.tagCategoryId,
    tagCategory: {
      name: t.tagCategory ? t.tagCategory.name : 'Uncategorized',
      color: getDefaultTagBackground(t?.tagCategory?.color),
      id: t.tagCategoryId,
      description: t.tagCategory?.description,
    },
  };
}
export function pageToTagData(
  data: InfiniteData<IPaginationResult<ITag>> | undefined,
): ITag[] {
  return data
    ? data.pages
        .map(pageData => pageData.results)
        .reduce(function reduce(prev, next) {
          return prev.concat(next);
        })
    : [];
}

function isTagDisabled(
  activeList: Pick<ITag, 'id'>[],
  tag: ITag,
): boolean | undefined {
  // Disable prefill behaviour.
  return !!activeList.find(item => item.id === tag.id);
}
export function ToTagList(
  // Activelist is new.
  activeList: Pick<ITag, 'id'>[],
  selectedTags: ITagLimitWithDesc[],
  setSelectedTags: SetState<ITagLimitWithDesc[]>,
): (
  value: ITag | undefined,
  index: number,
  array: (ITag | undefined)[],
) => JSX.Element | null {
  return tag => {
    if (!tag) return null;
    const { id } = tag;
    const disabled = isTagDisabled(activeList, tag);

    return (
      <TagsList
        key={id}
        tag={tag}
        disabled={disabled}
        onClick={() => {
          const isSelected = !!selectedTags.find(item => item.id === tag.id);

          if (isSelected) {
            setSelectedTags(selectedTags.filter(item => item.id !== tag.id));
          } else {
            setSelectedTags([...selectedTags, toITagLimitWithDesc(tag)]);
          }
        }}
      />
    );
  };
}
